import script from "./assetType.vue?vue&type=script&setup=true&lang=js"
export * from "./assetType.vue?vue&type=script&setup=true&lang=js"

import "./assetType.vue?vue&type=style&index=0&id=19d94288&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d94288"]])

export default __exports__